// Get the type of collage based on product's handle
const handle = window.product !== undefined ? window.product.handle : null;
const collageType = handle !== null ? handle.split("-")[0] +  "-" + handle.split("-")[1] : null;

// Return builder mask info based on type
const collages = {
  "square-1": {
    frame1: {
      width: 242,
      height: 365,
      left: 135,
      top: 10,
      canvasWidth: 7.625,
      canvasHeight: 11.5
    },
    frame2: {
      width: 114,
      height: 240,
      left: 10,
      top: 10,
      canvasWidth: 3.625,
      canvasHeight: 7.625
    },
    frame3: {
      width: 114,
      height: 114,
      left: 10,
      top: 260,
      canvasWidth: 3.625,
      canvasHeight: 3.625
    }
  },
  "square-2": {
    frame1: {
      width: 365,
      height: 178.5,
      left: 10,
      top: 10,
      canvasWidth: 11.5,
      canvasHeight: 5.625
    },
    frame2: {
      width: 177.5,
      height: 177.5,
      left: 10,
      top: 198.5,
      canvasWidth: 5.625,
      canvasHeight: 5.625
    },
    frame3: {
      width: 177.5,
      height: 177.5,
      left: 197.5,
      top: 198.5,
      canvasWidth: 5.625,
      canvasHeight: 5.625
    }
  },
  "square-3": {
    frame1: {
      width: 240.9,
      height: 365,
      left: 135,
      top: 10,
      canvasWidth: 7.59,
      canvasHeight: 11.5
    },
    frame2: {
      width: 115,
      height: 115,
      left: 10,
      top: 10,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame3: {
      width: 115,
      height: 115,
      left: 10,
      top: 135,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame4: {
      width: 115,
      height: 115,
      left: 10,
      top: 260,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    }
  },
  "square-4": {
    frame1: {
      width: 365,
      height: 271.766,
      left: 10,
      top: 10,
      canvasWidth: 11.5,
      canvasHeight: 8.5625
    },
    frame2: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 291.766,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame3: {
      width: 83.75,
      height: 83.75,
      left:  103.75,
      top: 291.766,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame4: {
      width: 83.75,
      height: 83.75,
      left: 197.5,
      top: 291.766,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame5: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 291.766,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    }
  },
  "square-5": {
    frame1: {
      width: 240,
      height: 240,
      left: 10,
      top: 10,
      canvasWidth: 7.59,
      canvasHeight: 7.59
    },
    frame2: {
      width: 115,
      height: 115,
      left: 10,
      top: 260,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame3: {
      width: 115,
      height: 115,
      left: 135,
      top: 260,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame4: {
      width: 115,
      height: 115,
      left: 260,
      top: 10,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame5: {
      width: 115,
      height: 115,
      left: 260,
      top: 135,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame6: {
      width: 115,
      height: 115,
      left: 260,
      top: 260,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    }
  },
  "square-6": {
    frame1: {
      width: 115,
      height: 115,
      left: 10,
      top: 10,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame2: {
      width: 115,
      height: 115,
      left: 135,
      top: 10,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame3: {
      width: 115,
      height: 115,
      left: 260,
      top: 10,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame4: {
      width: 115,
      height: 115,
      left: 10,
      top: 135,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame5: {
      width: 115,
      height: 115,
      left: 135,
      top: 135,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame6: {
      width: 115,
      height: 115,
      left: 260,
      top: 135,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame7: {
      width: 115,
      height: 115,
      left: 10,
      top: 260,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame8: {
      width: 115,
      height: 115,
      left: 135,
      top: 260,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    },
    frame9: {
      width: 115,
      height: 115,
      left: 260,
      top: 260,
      canvasWidth: 3.66,
      canvasHeight: 3.66
    }
  },
  "square-7": {
    frame1: {
      width: 177.5,
      height: 177.5,
      left: 103.75,
      top: 103.75,
      canvasWidth: 5.625,
      canvasHeight: 5.625
    },
    frame2: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame3: {
      width: 83.75,
      height: 83.75,
      left: 103.75,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame4: {
      width: 83.75,
      height: 83.75,
      left: 197.5,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame5: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame6: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 103.75,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame7: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 103.75,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame8: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 197.5,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame9: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 197.5,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame10: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame11: {
      width: 83.75,
      height: 83.75,
      left: 103.75,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame12: {
      width: 83.75,
      height: 83.75,
      left: 197.5,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame13: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    }
  },
  "square-8": {
    frame1: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame2: {
      width: 83.75,
      height: 83.75,
      left: 103.75,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame3: {
      width: 83.75,
      height: 83.75,
      left: 197.5,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame4: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 10,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame5: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 103.75,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame6: {
      width: 83.75,
      height: 83.75,
      left: 103.75,
      top: 103.75,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame7: {
      width: 83.75,
      height: 83.75,
      left: 197.5,
      top: 103.75,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame8: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 103.75,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame9: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 197.5,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame10: {
      width: 83.75,
      height: 83.75,
      left: 103.75,
      top: 197.5,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame11: {
      width: 83.75,
      height: 83.75,
      left: 197.5,
      top: 197.5,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame12: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 197.5,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame13: {
      width: 83.75,
      height: 83.75,
      left: 10,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame14: {
      width: 83.75,
      height: 83.75,
      left: 103.75,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame15: {
      width: 83.75,
      height: 83.75,
      left: 197.5,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    },
    frame16: {
      width: 83.75,
      height: 83.75,
      left: 291.25,
      top: 291.25,
      canvasWidth: 2.6875,
      canvasHeight: 2.6875
    }
  }
};

const collage = collages[collageType] || {};
Object.keys(collage).forEach((canvasKey) => {
  const { width, height, canvasWidth, canvasHeight } = collage[canvasKey];
  collage[
    canvasKey
  ].rawDimensions = `${height}_${width}_${canvasHeight}_${canvasWidth}`;
  collage[canvasKey].dimensions = `${canvasHeight}x${canvasWidth}`;
});

export default collage;
